export const FieldsetDataHooks = {
    Error: 'fiedset-error',
    LabelAsterisk: 'fieldset-label-asterisk',
};
//# sourceMappingURL=types.js.map